export default __webpack_public_path__ + "static/media/pattern1.2acd879e.webp";